import type {
  AberturaDeCaixa,
  CaixaAtual,
  CaixaDetalhado,
  CaixaFechado,
  CaixaNaLista,
  FechamentoDeCaixa,
  ForaDoCaixa,
  MovimentoDeCaixaInformado,
  MovimentoDoCaixa,
  PaginaDeCaixas,
} from '@arena/shared/schemas';
import { api } from './cliente.js';

/**
 * As chamadas do caixa da recepção — `#v-caixa`, documento 21.
 *
 * Um método por rota do `CaixaController`. `atual()` devolve `{ caixa }`
 * embrulhado: o Nest manda corpo vazio para `null`, e o cliente o leria
 * como `{}`.
 *
 * Ver: Arena_backend/Docs/plano/21-caixa-da-recepcao.md
 */
export const caixaApi = {
  /** O caixa aberto da arena, com o esperado ao vivo; `{ caixa: null }` se não há. */
  atual(): Promise<CaixaAtual> {
    return api<CaixaAtual>('/caixa/atual');
  },

  detalhe(id: string): Promise<CaixaDetalhado> {
    return api<CaixaDetalhado>(`/caixa/${id}`);
  },

  /** O histórico, do mais novo para o mais antigo; o cursor é opaco. */
  historico(consulta: { cursor?: string; limite?: number } = {}): Promise<PaginaDeCaixas> {
    const busca = new URLSearchParams();
    if (consulta.cursor) busca.set('cursor', consulta.cursor);
    if (consulta.limite) busca.set('limite', String(consulta.limite));
    const texto = busca.toString();
    return api<PaginaDeCaixas>(texto ? `/caixa?${texto}` : '/caixa');
  },

  /** O dinheiro do dia que não entrou em caixa nenhum. Sem `dia`, hoje na arena. */
  fora(consulta: { dia?: string } = {}): Promise<ForaDoCaixa> {
    return api<ForaDoCaixa>(
      consulta.dia ? `/caixa/fora?dia=${encodeURIComponent(consulta.dia)}` : '/caixa/fora',
    );
  },

  abrir(dados: AberturaDeCaixa): Promise<CaixaNaLista> {
    return api<CaixaNaLista>('/caixa', { metodo: 'POST', corpo: dados });
  },

  /** Sangria ou suprimento. Não lança no razão: só mexe no esperado. */
  movimentar(id: string, dados: MovimentoDeCaixaInformado): Promise<MovimentoDoCaixa> {
    return api<MovimentoDoCaixa>(`/caixa/${id}/movimentos`, { metodo: 'POST', corpo: dados });
  },

  /** Fecha com o contado. `esperadoConferido` é o que a tela mostrava: divergiu, é 409. */
  fechar(id: string, dados: FechamentoDeCaixa): Promise<CaixaFechado> {
    return api<CaixaFechado>(`/caixa/${id}/fechamento`, { metodo: 'POST', corpo: dados });
  },
};
